import React, { useRef, useState } from 'react'
import emailjs from "@emailjs/browser";


function Contact() {
  const form = useRef();
  const [errors, setErrors] = useState({});
  const [suggestedSubject, setSuggestedSubject] = useState("");




  const validateForm = () => {
    let newErrors = {};

    // Name: only letters & spaces
    const name = form.current["name"].value.trim();
    if (!name) {
      newErrors.name = "Name is required.";
    } else if (!/^[A-Za-z\s]+$/.test(name)) {
      newErrors.name = "Name can only contain letters and spaces.";
    }

    // Email validation
    const email = form.current["email"].value.trim();
    if (!email) {
      newErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    const subject = form.current["subject"].value.trim();
    if (!subject) {
      newErrors.subject = "Subject is required.";
    } else {
      let suggestion = subject.charAt(0).toUpperCase() + subject.slice(1);
      if (!/[.!?]$/.test(suggestion)) {
        suggestion += ".";
      }
      if (suggestion !== subject) {
        setSuggestedSubject(suggestion);
      } else {
        setSuggestedSubject("");
      }
    }

    const message = form.current["message"].value.trim();
    if (!message) {
      newErrors.message = "Message is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const sendEmail = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const now = new Date().toLocaleString();
      form.current.querySelector('input[name="time"]').value = now;
      const currentYear = new Date().getFullYear();

      emailjs
        .sendForm(
          "service_u3d9pop",
          "template_lopke4b",
          form.current,
          "rPaKJkBM1s-ZgawMN",
          {
            year:currentYear,
          }
        )
        .then(
          (result) => {
            console.log("✅ Email sent:", result.text);
            alert("Message sent successfully!");
            form.current.reset();
          },
          (error) => {
            console.error("❌ Error:", error.text);
            alert("Failed to send message.");
          }
        );
    }
  };
  const clearForm = () => {
    form.current.reset(); // Resets the form fields
    setErrors({}); // Clears the error messages
    setSuggestedSubject(""); // Clears the suggested subject
  };
  


  return (
    <>
      <section className="inner-banner-wrap" style={{ overflowX: "hidden" }}>
        <div
          className="inner-baner-container"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        >
          <div className="container">
            <div className="inner-banner-content">
              <h1 className="inner-title">Contact</h1>
            </div>
          </div>
        </div>
      </section>

      <div className="contact-page-section">
        <div className="contact-form-inner">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="contact-detail-container">
                  <div className="section-heading">
                    <div className="title-divider" />
                    <h2 className="section-title">
                      Contact Us &amp;{" "}
                      <span className="primary-color">Reach !!</span>
                    </h2>
                    <p>
                      We're here to empower your business with innovative tech solutions.
                      Reach out to our expert team to discuss your project, explore collaboration
                      opportunities, or get personalized support. Let’s build the future together
                    </p>
                  </div>
                  <div className="contact-details-list">
                    <h3 className="primary-bg">100+ Worldwide Projects</h3>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="contact-details">
                          <h4>Main Branch</h4>
                          <ul>
                            <li>
                              <a
                                href="https://www.google.com/maps/search/?api=1&query=The+Executive+Zone+Anna+Salai+Chennai"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: "none", color: "inherit" }}
                              >
                                <i className="fas fa-map-marker-alt" aria-hidden="true" />
                                The Executive Zone (Shakti Towers) 600002, Chennai
                              </a>
                            </li>

                            <li>
                              <a href="mailto:info@codenixinfotech.com">
                                <i className="fas fa-envelope-open-text" aria-hidden="true" />
                                <span>info@codenixinfotech.com</span>
                              </a>
                            </li>
                            <li>
                              <a href="tel:+919944887286">
                                <i className="fas fa-phone-volume" aria-hidden="true" />
                                (+91) 9629456090
                              </a>
                            </li>

                          </ul>
                        </div>
                      </div>
                      <div className="col-sm-6 d-none">
                        <div className="contact-details mt-2">
                          <h4>NEWYORK CITY</h4>
                          <ul>
                            <li>
                              <i
                                aria-hidden="true"
                                className="fas fa-map-marker-alt"
                              />
                              Street, Newyork City 10002 United States
                            </li>
                            <li>
                              <a href="https://demo.bosathemes.com/cdn-cgi/l/email-protection#70191e161f30141f1d11191e5e131f1d">
                                <i
                                  aria-hidden="true"
                                  className="fas fa-envelope-open-text"
                                />
                                <span
                                  className="__cf_email__"
                                  data-cfemail="2940474f46694d4644484047074a4644"
                                >
                                  info@domain.com
                                </span>
                              </a>
                            </li>
                            <li>
                              <a href="tellto:888901234789">
                                <i
                                  aria-hidden="true"
                                  className="fas fa-phone-volume"
                                />
                                (888)9012-34-789
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="toll-feee d-none">
                      <ul>
                        <li>
                          Toll free:
                          <a href="tellto:18578990009">1 (857) 899-0009</a>
                        </li>
                        <li>
                          Mail us:
                          <a href="https://demo.bosathemes.com/cdn-cgi/l/email-protection#0960676f66496d6664686067276a6664">
                            <span
                              className="__cf_email__"
                              data-cfemail="8fe6e1e9e0cfebe0e2eee6e1a1ece0e2"
                            >
                              info@domain.com
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-6 mt-2">
            <div className="contact-from-wrap">
              <form ref={form} onSubmit={sendEmail} className="contact-from">
                <p>
                  <input type="text" name="name" placeholder="Enter Name*" />
                </p>
                <p>
                  <input type="email" name="email" placeholder="Enter Email*" />
                </p>
                <p>
                  <input
                    type="text"
                    name="subject"
                    placeholder="Enter Subject*"
                  />
                </p>
                <input type="hidden" name="time" />
                <p>
                  <textarea
                    rows={8}
                    name='message'
                    placeholder="Enter Message*"
                    defaultValue={""}
                  />
                </p>
                <p>
                  <input
                    type="submit"
                    name="submit"
                    // defaultValue="SUBMIT MESSAGE"
                  />
                </p>
              </form>
            </div>
          </div> */}
              <div className="col-md-6 mt-2">
                <div className="contact-from-wrap">
                  <form ref={form} onSubmit={sendEmail} className="contact-from">
                    <p>
                      <input type="text" name="name" placeholder="Enter Name*" />
                      {errors.name && <span className="error text-danger">{errors.name}</span>}
                    </p>
                    <p>
                      <input type="email" name="email" placeholder="Enter Email*" />
                      {errors.email && <span className="error text-danger">{errors.email}</span>}
                    </p>
                    <p>
                      <input type="text" name="subject" placeholder="Enter Subject*" />
                      {errors.subject && <span className="error text-danger">{errors.subject}</span>}

                    </p>
                    <input type="hidden" name="time" />
                    <p>
                      <textarea
                        rows={8}
                        name="message"
                        placeholder="Enter Message*"
                        defaultValue={""}
                      />
                      {errors.message && <span className="error text-danger">{errors.message}</span>}
                    </p>
                    <p className="d-flex gap-2">
                    <input type="submit" name="submit" value="Submit" />
                    <input
                    type="button"
                    onClick={clearForm}
                    value="Cancel"
                    className="btn btn-secondary btn-sm"
                    style={{ padding: "15px 30px", width: "auto",textTransform:"uppercase" }}
                  />
                  </p>



                  </form>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="map-section">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2511.627951632478!2d80.25897487885497!3d13.06097808973902!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5266166d42b5a7%3A0xd997f32439e5bb34!2sThe%20Executive%20Zone%20%7C%20Coworking%20Space%20%7C%20Anna%20Salai!5e0!3m2!1sen!2sin!4v1765953993487!5m2!1sen!2sin"
            width="100%"
            height="500"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
          </div>

      </div>
    </>

  )
}

export default Contact
